var _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLegalDisclaimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M18 10a3.001 3.001 0 00-3 3v16a1 1 0 001 1 1 1 0 001-1V13a.999.999 0 011-1h4a.999.999 0 011 1v16a1 1 0 001 1 1 1 0 001-1V13a3.001 3.001 0 00-3-3z",
    color: "#000",
    fill: "#3a424c"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      InkscapeStroke: "none"
    },
    d: "M12 14c-1.645 0-3 1.355-3 3v10c0 1.645 1.355 3 3 3h16c1.645 0 3-1.355 3-3V17c0-1.645-1.355-3-3-3zm0 2h16c.564 0 1 .436 1 1v10c0 .564-.436 1-1 1H12c-.564 0-1-.436-1-1V17c0-.564.436-1 1-1z",
    color: "#000",
    fill: "#3a424c"
  }));
}

export default SvgLegalDisclaimer;